import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, requiredRole }) {
  const { isAuthenticated, role, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={"/login?next=" + encodeURIComponent(location.pathname)} replace />;
  }

  const effectiveRole = role || "user";

  if (requiredRole && effectiveRole !== requiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
